var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datatable',{ref:"dtComponent",attrs:{"modelData":_vm.dtData},on:{"deleteItem":_vm.deleteRoleItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }